import React from "react";
import Button from "../components/Button";
import styles from "./NotFound.module.css";

interface NotFoundMessage {
  title: string;
  message: string;
}

const SILLY_MESSAGES: Readonly<NotFoundMessage[]> = [
  {
    title: "Oops! Page not found",
    message: "Looks like this page went on vacation without telling us! 🏖️",
  },
  {
    title: "404 — Lost in cyberspace",
    message:
      "Even our best developers can’t find this page. Maybe it’s hiding behind the couch? 🛋️",
  },
  {
    title: "Houston, we have a problem",
    message:
      "This page has floated away into the digital void. Send a search party! 🚀",
  },
  {
    title: "Page not found",
    message:
      "Our intern must have accidentally deleted this page while getting coffee ☕",
  },
  {
    title: "404 error",
    message:
      "This page is playing hide and seek, and it’s really, really good at it! 🙈",
  },
  {
    title: "Whoopsie daisy!",
    message:
      "Looks like you’ve discovered the mysterious land of missing pages! 🗺️",
  },
];

const NotFound: React.FC = () => {
  const [msg] = React.useState(() => {
    const i = (Math.random() * SILLY_MESSAGES.length) | 0;
    return SILLY_MESSAGES[i];
  });

  return (
    <div className={styles.notFound}>
      <div className={styles.content}>
        <div className={styles.text}>
          <h1 className={styles.title}>{msg.title}</h1>
          <p className={styles.message}>{msg.message}</p>
        </div>

        <div className={styles.actions}>
          <Button href="/" size="large">
            Take Me Home
          </Button>
        </div>
      </div>
    </div>
  );
};

NotFound.displayName = "NotFound";

export default NotFound;
